/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb135Inputs */

const en__field_enum_pbs_fb135 = /** @type {(inputs: _Field_Enum_Pbs_Fb135Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 13 Faculty of Physics`)
};

const de__field_enum_pbs_fb135 = /** @type {(inputs: _Field_Enum_Pbs_Fb135Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 13 Physik`)
};

/**
* | output |
* | --- |
* | "F 13 Faculty of Physics" |
*
* @param {_Field_Enum_Pbs_Fb135Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb135 = /** @type {((inputs?: _Field_Enum_Pbs_Fb135Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb135Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb135(inputs)
	return de__field_enum_pbs_fb135(inputs)
});
export { _field_enum_pbs_fb135 as "_field_enum_PBS_FB13" }